import { AnimalDef, ChainDef } from './animalDef'

export class AnimalDefinitions {
  static getPig () {
    const def = new AnimalDef()

    // body:
    def.imageName = 'pig'
    def.isNewImage = true
    def.sendTailToBack = true
    def.hasEars = true

    // tail:
    const tailInfo = new ChainDef()
    tailInfo.length = 2
    tailInfo.pos = { x: 0, y: 30 }
    tailInfo.limbColor = 0xFABFB7
    tailInfo.scalingFunction = (i) => { return { x: 0.4, y: 0.6 } }
    tailInfo.handColor = 0xFABFB7
    tailInfo.limbImage = 'limb'
    tailInfo.handImage = 'unicorn_tail'
    def.tailInfos = [tailInfo]

    // limbs:
    def.leftArmInfo.length = 2
    def.leftArmInfo.pos = { x: 22, y: -13 }
    def.leftArmInfo.limbColor = 0xFABFB7
    def.leftArmInfo.handColor = 0xBC918B
    def.leftArmInfo.handImage = 'pig_feet'
    def.leftArmInfo.isNewImage = true

    def.rightArmInfo.length = 2
    def.rightArmInfo.pos = { x: -22, y: -13 }
    def.rightArmInfo.limbColor = 0xFABFB7
    def.rightArmInfo.handColor = 0xBC918B
    def.rightArmInfo.handImage = 'pig_feet'
    def.rightArmInfo.isNewImage = true

    def.leftLegInfo.length = 2
    def.leftLegInfo.pos = { x: 24, y: 20 }
    def.leftLegInfo.limbColor = 0xFABFB7
    def.leftLegInfo.handColor = 0xBC918B
    def.leftLegInfo.handImage = 'pig_feet'
    def.leftLegInfo.isNewImage = true

    def.rightLegInfo.length = 2
    def.rightLegInfo.pos = { x: -24, y: 20 }
    def.rightLegInfo.limbColor = 0xFABFB7
    def.rightLegInfo.handColor = 0xBC918B
    def.rightLegInfo.handImage = 'pig_feet'
    def.rightLegInfo.isNewImage = true

    def.leftEarInfo.length = 1
    def.leftEarInfo.pos = { x: 18, y: -30 }
    def.leftEarInfo.limbColor = 0xFABFB7
    def.leftEarInfo.handColor = 0xFABFB7
    def.leftEarInfo.handImage = 'unicorn_tail'

    def.rightEarInfo.length = 1
    def.rightEarInfo.pos = { x: -18, y: -30 }
    def.rightEarInfo.limbColor = 0xFABFB7
    def.rightEarInfo.handColor = 0xFABFB7
    def.rightEarInfo.handImage = 'unicorn_tail'

    return def
  }

  static getCat () {
    const def = new AnimalDef()
    def.imageName = 'cat'
    def.isNewImage = true
    const tailInfo = this.createChainInfo(8, 0, 30, 0xFCB86F, 0xFCB86F)
    def.tailInfos = [tailInfo]
    def.leftArmInfo = this.createChainInfo(2, 18, -13, 0xFCB86F, 0xFFFFFF)
    def.rightArmInfo = this.createChainInfo(2, -18, -13, 0xFCB86F, 0xFFFFFF)
    def.leftLegInfo = this.createChainInfo(4, 21, 21, 0xFCB86F, 0xFFFFFF)
    def.rightLegInfo = this.createChainInfo(4, -21, 21, 0xFCB86F, 0xFFFFFF)

    return def
  }

  static getBlackCat () {
    const def = this.getCat()
    def.imageName = 'black_cat'
    def.tailInfos[0].limbColor = 0x555555
    def.tailInfos[0].handColor = 0x555555
    def.leftArmInfo.limbColor = 0x555555
    def.leftArmInfo.handColor = 0x666666
    def.rightArmInfo.limbColor = 0x555555
    def.rightArmInfo.handColor = 0x666666
    def.leftLegInfo.limbColor = 0x555555
    def.leftLegInfo.handColor = 0x666666
    def.rightLegInfo.limbColor = 0x555555
    def.rightLegInfo.handColor = 0x666666
    return def
  }

  static getWhiteCat () {
    const def = this.getCat()
    def.imageName = 'white_cat'
    def.tailInfos[0].limbColor = 0xF0DBC8
    def.tailInfos[0].handColor = 0xF0DBC8
    def.leftArmInfo.limbColor = 0xF0DBC8
    def.leftArmInfo.handColor = 0xFFFFEE
    def.rightArmInfo.limbColor = 0xF0DBC8
    def.rightArmInfo.handColor = 0xFFFFEE
    def.leftLegInfo.limbColor = 0xF0DBC8
    def.leftLegInfo.handColor = 0xFFFFEE
    def.rightLegInfo.limbColor = 0xF0DBC8
    def.rightLegInfo.handColor = 0xFFFFEE
    return def
  }

  static getDog () {
    const def = new AnimalDef()
    def.imageName = 'dog'
    def.isNewImage = true
    def.sendTailToBack = true
    const tailInfo = this.createChainInfo(6, 0, 30, 0xFEA726, 0xFEA726)
    tailInfo.handImage = 'unicorn_tail'
    tailInfo.scalingFunction = (i) => {
      const scale = 0.6 + (0.025 * i)
      return { x: scale, y: scale }
    }
    def.tailInfos = [tailInfo]
    def.leftArmInfo = this.createChainInfo(1, 18, 0, 0xFEA726, 0xFEF1DD)
    def.rightArmInfo = this.createChainInfo(1, -18, 0, 0xFEA726, 0xFEF1DD)
    def.leftLegInfo = this.createChainInfo(1, 21, 21, 0xFEA726, 0xFEF1DD)
    def.rightLegInfo = this.createChainInfo(1, -21, 21, 0xFEA726, 0xFEF1DD)

    return def
  }

  static getPug () {
    const def = new AnimalDef()

    // body:
    def.imageName = 'pug'
    def.isNewImage = true
    def.sendTailToBack = true

    def.hasEars = true

    // tail:
    const tailInfo = new ChainDef()
    tailInfo.length = 2
    tailInfo.pos = { x: 0, y: 30 }
    tailInfo.limbColor = 0xEACE9C
    tailInfo.handColor = 0xEACE9C
    tailInfo.limbImage = 'limb'
    tailInfo.handImage = 'limb'
    def.tailInfos = [tailInfo]

    // limbs:
    def.leftArmInfo.length = 1
    def.leftArmInfo.pos = { x: 28, y: 5 }
    def.leftArmInfo.limbColor = 0xEACE9C
    def.leftArmInfo.handColor = 0xEACE9C

    def.rightArmInfo.length = 1
    def.rightArmInfo.pos = { x: -28, y: -5 }
    def.rightArmInfo.limbColor = 0xEACE9C
    def.rightArmInfo.handColor = 0xEACE9C

    def.leftLegInfo.length = 1
    def.leftLegInfo.pos = { x: 18, y: 22 }
    def.leftLegInfo.limbColor = 0xEACE9C
    def.leftLegInfo.handColor = 0xEACE9C

    def.rightLegInfo.length = 1
    def.rightLegInfo.pos = { x: -18, y: 22 }
    def.rightLegInfo.limbColor = 0xEACE9C
    def.rightLegInfo.handColor = 0xEACE9C

    def.leftEarInfo = this.createChainInfo(1, 26, -30, 0x56332B, 0x56332B)
    def.leftEarInfo.handImage = 'unicorn_tail'

    def.rightEarInfo = this.createChainInfo(1, -26, -30, 0x56332B, 0x56332B)
    def.rightEarInfo.handImage = 'unicorn_tail'

    return def
  }

  static getRobot () {
    const def = new AnimalDef()
    def.imageName = 'robot'
    def.hasLegs = false
    def.stiffenNeck = true
    def.sendTailToBack = true
    const tailInfo = this.createChainInfo(4, 0, -35, 0x000000, 0x000000)
    tailInfo.limbImage = 'robot_limb'
    tailInfo.handImage = 'robot_limb'
    tailInfo.dist = 4
    tailInfo.scalingFunction = (i) => {
      if (i === 3) {
        return { x: 0.45, y: 0.45 }
      } else {
        return { x: 0.1, y: 0.6 }
      }
    }
    def.tailInfos = [tailInfo]

    def.leftArmInfo = this.createChainInfo(4, 30, -10, 0xCECECE, 0xffffff)
    def.leftArmInfo.limbImage = 'robot_limb'
    def.leftArmInfo.handImage = 'robot_hand'
    def.leftArmInfo.scalingFunction = (i) => { return { x: 0.7 + i * 0.1, y: 0.7 + i * 0.1 } }
    def.leftArmInfo.dist = 12

    def.rightArmInfo = this.createChainInfo(4, -30, -10, 0xCECECE, 0xffffff)
    def.rightArmInfo.limbImage = 'robot_limb'
    def.rightArmInfo.handImage = 'robot_hand'
    def.rightArmInfo.scalingFunction = (i) => { return { x: 0.7 + i * 0.1, y: 0.7 + i * 0.1 } }
    def.rightArmInfo.dist = 12
    return def
  }

  static getBunny () {
    const def = new AnimalDef()
    def.imageName = 'bunny'
    def.stiffenNeck = true
    def.tailInFront = true

    const tailInfo1 = this.createChainInfo(6, 13, -28, 0xFFFFFF, 0xFFFFFF)
    tailInfo1.scalingFunction = (i) => { return { x: 1 - (0.06 * (6 - i)), y: 0.9 } }
    const tailInfo2 = this.createChainInfo(6, -13, -28, 0xFFFFFF, 0xFFFFFF)
    tailInfo2.scalingFunction = (i) => { return { x: 1 - (0.06 * (6 - i)), y: 0.9 } }
    def.tailInfos = [tailInfo1, tailInfo2]

    def.leftArmInfo = this.createChainInfo(2, 27, -12, 0xFFFFFF, 0xFFFFFF)
    def.rightArmInfo = this.createChainInfo(2, -27, -12, 0xFFFFFF, 0xFFFFFF)
    def.leftLegInfo = this.createChainInfo(2, 10, 27, 0xFFFFFF, 0xFFFFFF)
    def.rightLegInfo = this.createChainInfo(2, -10, 27, 0xFFFFFF, 0xFFFFFF)
    return def
  }

  static getPanda () {
    const def = new AnimalDef()
    def.imageName = 'panda'
    def.isNewImage = 'panda'
    def.hasTail = false

    def.leftArmInfo = this.createChainInfo(2, 30, -9, 0x000000, 0x000000)
    def.rightArmInfo = this.createChainInfo(2, -30, -9, 0x000000, 0x000000)
    def.leftLegInfo = this.createChainInfo(2, 20, 24, 0x000000, 0x000000)
    def.rightLegInfo = this.createChainInfo(2, -20, 24, 0x000000, 0x000000)

    return def
  }

  static getFish () {
    const def = new AnimalDef()
    def.imageName = 'fish'
    def.isNewImage = true
    def.hasLegs = false
    def.sendTailToBack = true

    const tailInfo = this.createChainInfo(2, 0, 28, 0xB79631, 0xB79631)
    tailInfo.handImage = 'unicorn_tail'
    const tailInfo2 = this.createChainInfo(2, 0, -28, 0xB79631, 0xB79631)
    tailInfo2.handImage = 'unicorn_tail'
    def.tailInfos = [tailInfo, tailInfo2]

    def.leftArmInfo = this.createChainInfo(1, 30, 0, 0xEAC23F, 0xEAC23F)
    def.leftArmInfo.handImage = 'fish_fin'
    def.leftArmInfo.isNewImage = true
    def.rightArmInfo = this.createChainInfo(1, -30, 0, 0xEAC23F, 0xEAC23F)
    def.rightArmInfo.handImage = 'fish_fin'
    def.rightArmInfo.isNewImage = true

    return def
  }

  static getPenguin () {
    const def = new AnimalDef()
    def.imageName = 'penguin'
    def.isNewImage = true
    def.hasTail = false

    def.leftArmInfo = this.createChainInfo(2, 28, -6, 0x000000, 0x000000)
    def.leftArmInfo.limbImage = 'robot_limb'
    def.leftArmInfo.handImage = 'unicorn_tail'
    def.leftArmInfo.dist = 12
    def.leftArmInfo.scalingFunction = (i) => {
      const scale = i === 0 ? 0.8 : 1.0
      return { x: 0.8, y: scale }
    }

    def.rightArmInfo = this.createChainInfo(2, -28, -6, 0x000000, 0x000000)
    def.rightArmInfo.limbImage = 'robot_limb'
    def.rightArmInfo.handImage = 'unicorn_tail'
    def.rightArmInfo.dist = 12
    def.rightArmInfo.scalingFunction = (i) => {
      const scale = i === 0 ? 0.8 : 1.0
      return { x: 0.8, y: scale }
    }

    def.leftLegInfo = this.createChainInfo(1, 10, 24, 0xFFFF00, 0xFFFF00)
    def.leftLegInfo.handImage = 'penguin_feet'
    def.leftLegInfo.isNewImage = true
    // def.leftLegInfo.scalingFunction = (i) => { return { x: 0.7, y: 0.7 } }
    def.rightLegInfo = this.createChainInfo(1, -10, 24, 0xFFFF00, 0xFFFF00)
    def.rightLegInfo.handImage = 'penguin_feet'
    def.rightLegInfo.isNewImage = true
    // def.rightLegInfo.scalingFunction = (i) => { return { x: 0.7, y: 0.7 } }

    return def
  }

  static getUnicorn () {
    const def = new AnimalDef()
    def.imageName = 'unicorn'
    def.sendTailToBack = true

    const tailInfo1 = this.createChainInfo(9, -8, 28, 0xF954F7, 0xF954F7)
    tailInfo1.handImage = 'unicorn_tail'
    tailInfo1.scalingFunction = (i) => { return { x: 1 - (0.06 * (6 - i)), y: 0.9 } }
    const tailInfo2 = this.createChainInfo(9, 8, 28, 0xF92231, 0xF92231)
    tailInfo2.handImage = 'unicorn_tail'
    tailInfo2.scalingFunction = (i) => { return { x: 1 - (0.06 * (6 - i)), y: 0.9 } }
    const tailInfo3 = this.createChainInfo(10, 0, 28, 0xF9F62F, 0xF9F62F)
    tailInfo3.handImage = 'unicorn_tail'
    tailInfo3.scalingFunction = (i) => { return { x: 1 - (0.06 * (6 - i)), y: 0.9 } }
    def.tailInfos = [tailInfo1, tailInfo2, tailInfo3]

    def.leftArmInfo = this.createChainInfo(2, 27, -9, 0xFBE1EC, 0xFFF6B2)
    def.rightArmInfo = this.createChainInfo(2, -27, -9, 0xFBE1EC, 0xFFF6B2)
    def.leftLegInfo = this.createChainInfo(2, 20, 24, 0xFBE1EC, 0xFFF6B2)
    def.rightLegInfo = this.createChainInfo(2, -20, 24, 0xFBE1EC, 0xFFF6B2)

    return def
  }

  static getGiraffe () {
    const def = new AnimalDef()
    def.imageName = 'giraffe_body'
    def.stiffenNeck = true
    def.tailInFront = true

    const tailInfo = this.createChainInfo(6, 0, -27, 0xE5B95A, 0xffffff)
    tailInfo.limbImage = 'giraffe_limb'
    tailInfo.handImage = 'giraffe_head'
    tailInfo.scalingFunction = (i) => {
      if (i === 5) {
        return { x: 1, y: 1 }
      } else {
        const scale = 0.3 + (0.1 * (6 - i))
        return { x: scale, y: scale }
      }
    }
    def.tailInfos = [tailInfo]

    def.leftArmInfo = this.createChainInfo(2, 24, -5, 0xE5B95A, 0xE5B95A)
    def.leftArmInfo.limbImage = 'giraffe_limb'
    def.leftArmInfo.handImage = 'giraffe_limb'
    def.rightArmInfo = this.createChainInfo(2, -24, -5, 0xE5B95A, 0xE5B95A)
    def.rightArmInfo.limbImage = 'giraffe_limb'
    def.rightArmInfo.handImage = 'giraffe_limb'
    def.leftLegInfo = this.createChainInfo(2, 21, 21, 0xE5B95A, 0xE5B95A)
    def.leftLegInfo.limbImage = 'giraffe_limb'
    def.leftLegInfo.handImage = 'giraffe_limb'
    def.rightLegInfo = this.createChainInfo(2, -21, 21, 0xE5B95A, 0xE5B95A)
    def.rightLegInfo.limbImage = 'giraffe_limb'
    def.rightLegInfo.handImage = 'giraffe_limb'

    return def
  }

  static getRacoon () {
    const def = new AnimalDef()
    def.imageName = 'racoon'
    def.isNewImage = true
    def.sendTailToBack = true
    const tailInfo = this.createChainInfo(8, 0, 20, 0xB7B7B7, 0xB7B7B7)
    tailInfo.colorFunction = (i) => {
      return i % 2 === 0 || i >= tailInfo.length - 2 ? 0xffffff : 0xC1895B
    }
    tailInfo.limbImage = 'robot_limb'
    tailInfo.handImage = 'unicorn_tail'
    tailInfo.scalingFunction = (i) => {
      const perc = 1 - Math.abs((i / 7) - 0.5)
      const scale = Math.max(perc, 0.65)
      return { x: 1.25 * scale, y: scale }
    }
    def.tailInfos = [tailInfo]
    def.leftArmInfo = this.createChainInfo(1, 28, 0, 0xC1895B, 0xC1895B)
    def.rightArmInfo = this.createChainInfo(1, -28, 0, 0xC1895B, 0xC1895B)
    def.leftLegInfo = this.createChainInfo(1, 21, 21, 0xC1895B, 0xC1895B)
    def.rightLegInfo = this.createChainInfo(1, -21, 21, 0xC1895B, 0xC1895B)

    return def
  }

  static getMouse () {
    const def = new AnimalDef()
    def.imageName = 'mouse'
    def.isNewImage = true
    def.sendTailToBack = true
    const tailInfo = this.createChainInfo(8, 0, 30, 0xB7B7B7, 0xB7B7B7)
    // tailInfo.limbColor = 0xFFD3E0
    // tailInfo.handColor = 0xFFD3E0
    tailInfo.colorFunction = (i) => {
      return i % 2 === 0 ? 0xF2C9D5 : 0xFFD3E0
    }
    tailInfo.handImage = 'unicorn_tail'
    tailInfo.scalingFunction = (i) => {
      const scale = 0.5 - (i * 0.02)
      return { x: scale, y: scale }
    }
    def.tailInfos = [tailInfo]
    def.leftArmInfo = this.createChainInfo(1, 18, -13, 0xB7B7B7, 0xB7B7B7)
    def.rightArmInfo = this.createChainInfo(1, -18, -13, 0xB7B7B7, 0xB7B7B7)
    def.leftLegInfo = this.createChainInfo(1, 21, 21, 0xB7B7B7, 0xB7B7B7)
    def.rightLegInfo = this.createChainInfo(1, -21, 21, 0xB7B7B7, 0xB7B7B7)

    return def
  }

  static getTurtle () {
    const def = new AnimalDef()
    def.imageName = 'turtle'
    def.isNewImage = true
    def.stiffenNeck = true
    def.tailInFront = true

    const tailInfo = this.createChainInfo(3, 0, -32, 0xE5B95A, 0xffffff)
    tailInfo.limbImage = 'robot_limb'
    tailInfo.handImage = 'turtle_head'
    tailInfo.isNewImage = true
    tailInfo.scalingFunction = (i) => {
      if (i === 2) {
        return { x: 1, y: 1 }
      } else {
        const scale = 0.6// 3 + (0.1 * (6 - i))
        return { x: scale, y: scale }
      }
    }
    def.tailInfos = [tailInfo]

    def.leftArmInfo = this.createChainInfo(2, 24, -20, 0xE5B95A, 0xE5B95A)
    def.leftArmInfo.limbImage = 'robot_limb'
    def.leftArmInfo.handImage = 'unicorn_tail'
    def.rightArmInfo = this.createChainInfo(2, -24, -20, 0xE5B95A, 0xE5B95A)
    def.rightArmInfo.limbImage = 'robot_limb'
    def.rightArmInfo.handImage = 'unicorn_tail'
    def.leftLegInfo = this.createChainInfo(2, 17, 24, 0xE5B95A, 0xE5B95A)
    def.leftLegInfo.limbImage = 'robot_limb'
    def.leftLegInfo.handImage = 'unicorn_tail'
    def.rightLegInfo = this.createChainInfo(2, -17, 24, 0xE5B95A, 0xE5B95A)
    def.rightLegInfo.limbImage = 'robot_limb'
    def.rightLegInfo.handImage = 'unicorn_tail'

    return def
  }

  static getJelly () {
    const color = 0x9DD5EE
    const def = new AnimalDef()

    // body:
    def.imageName = 'jelly'
    def.isNewImage = true
    def.hasLegs = false
    def.hasArms = false
    // def.bodyInFront = true
    def.stiffenNeck = true

    // tail:
    const tailInfo1 = this.createChainInfo(5, 15, 25, color, color)
    tailInfo1.scalingFunction = (i) => { return { x: 0.45, y: 0.45 } }
    const tailInfo2 = this.createChainInfo(5, -15, 25, color, color)
    tailInfo2.scalingFunction = (i) => { return { x: 0.45, y: 0.45 } }
    const tailInfo3 = this.createChainInfo(8, 8, 18, color, color)
    tailInfo3.scalingFunction = (i) => { return { x: 0.45, y: 0.45 } }
    const tailInfo4 = this.createChainInfo(8, -8, 18, color, color)
    tailInfo4.scalingFunction = (i) => { return { x: 0.45, y: 0.45 } }
    tailInfo1.handImage = 'unicorn_tail'
    tailInfo2.handImage = 'unicorn_tail'
    tailInfo3.handImage = 'unicorn_tail'
    tailInfo4.handImage = 'unicorn_tail'
    def.tailInfos = [tailInfo1, tailInfo2, tailInfo3, tailInfo4]

    def.leftArmInfo = this.createChainInfo(4, 24, 15, color, color)
    def.leftArmInfo.scalingFunction = (i) => { return { x: 0.45, y: 0.45 } }
    def.rightArmInfo = this.createChainInfo(4, -24, 15, color, color)
    def.rightArmInfo.scalingFunction = (i) => { return { x: 0.45, y: 0.45 } }

    def.leftArmInfo.handImage = 'unicorn_tail'
    def.rightArmInfo.handImage = 'unicorn_tail'

    return def
  }

  static getElephant () {
    const color = 0x9E9E9E
    const def = new AnimalDef()
    def.imageName = 'elephant'
    def.tailInFront = true
    const tailInfo = this.createChainInfo(5, 0, -22, color, color)
    tailInfo.scalingFunction = (i) => {
      const scale = 0.4 + (0.05 * (6 - i))
      return { x: scale, y: scale }
    }
    def.tailInfos = [tailInfo]
    def.leftArmInfo = this.createChainInfo(1, 24, -5, color, color)
    def.rightArmInfo = this.createChainInfo(1, -24, -5, color, color)
    def.leftLegInfo = this.createChainInfo(1, 21, 21, color, color)
    def.rightLegInfo = this.createChainInfo(1, -21, 21, color, color)
    return def
  }

  static createChainInfo (length, posX, posY, limbColor, handColor) {
    const info = new ChainDef()
    info.length = length
    info.pos = { x: posX, y: posY }
    info.limbColor = limbColor
    info.handColor = handColor
    return info
  }
}
